import { Timestamp } from 'firebase/firestore';

export interface Attachment {
  id: string;
  name: string;
  url: string;
  type: string;
  size: number;
}

export interface Reaction {
  type: 'like' | 'love' | 'celebrate' | 'insightful' | 'support';
  userId: string;
}

export interface PostView {
  userId: string;
  userName: string;
  firstViewedAt: string;
}

export interface BaseContent {
  id?: string;
  title: string;
  authorId: string;
  created_at: Timestamp;
  hidden?: boolean;
  reactions?: Reaction[];
}

export interface TimelinePost extends BaseContent {
  content: string;
  category: 'timeline';
  timelinePostCategory: 'Update' | 'Newsletter' | 'Announcement';
  attachments?: Attachment[];
}

export interface FinancialReport extends BaseContent {
  content: string; // This will be used for 'Comments'
  category: 'report';
  attachments?: Attachment[];
}

export interface Meeting extends BaseContent {
  type: 'AGM' | 'EGM' | 'Information' | 'Norway AGM' | 'Norway EGM';
  title: string;
  date: string;
  time: string;
  timezone: string;
  venue: 'Virtual' | 'In-Person' | 'Hybrid';
  physicalVenue?: string;
  meetingLink?: string;
  agenda: string;
  additionalInfo?: string;
  contactEmail: string;
  contactPhone: string;
  category: 'meeting';
  authorId: string;
  created_at: Timestamp;
  attachments?: Attachment[];
  attendees?: string[];
}

export type Post = TimelinePost | Meeting | FinancialReport;

export interface PostViewRecord {
  id: string;
  postId: string;
  userId: string;
  userName: string;
  firstViewedAt: string;
  category: 'timeline' | 'meeting' | 'report';
}

export interface MeetingFormData {
  type: 'AGM' | 'EGM' | 'Information' | 'Norway AGM' | 'Norway EGM';
  title: string;
  date: string;
  time: string;
  timezone: string;
  venue: 'Virtual' | 'In-Person' | 'Hybrid';
  physicalVenue?: string;
  meetingLink?: string;
  agenda: string;
  additionalInfo?: string;
  contactEmail: string;
  contactPhone: string;
}

export const defaultFormData: MeetingFormData = {
  type: 'AGM',
  title: '',
  date: '',
  time: '',
  timezone: 'Africa/Nairobi',
  venue: 'Virtual',
  physicalVenue: '',
  meetingLink: '',
  agenda: '',
  additionalInfo: '',
  contactEmail: '',
  contactPhone: ''
}; 